/* ============================================================================
   MSCVTR pak-configurator (wizard). Vanilla JS, geen dependencies.

   - Bouwt de stappen dynamisch op uit window.MSCVTR_SUIT_OPTIONS[handle]
     (voering, knopen, zakken, bandplooi, broekafwerking + vrije tekst).
   - Colbert-/pantalonmaten, de lettermaat-mapping, de maatcalculator en de
     maattabellen staan HIERONDER centraal en gelden voor alle pakken.
   - Keuzes worden opgeslagen als line item properties en in localStorage bewaard.
   - Toevoegen aan winkelwagen gebeurt alleen via de laatste stap; daarna gaat
     de klant naar de volledige winkelwagenpagina (ruim overzicht).

   Aanpassen doe je vooral in het blok "CENTRALE MAAT-CONFIGURATIE" hieronder.
   ========================================================================== */
(function () {
  'use strict';

  /* ==========================================================================
     CENTRALE MAAT-CONFIGURATIE  (pas hier aan, op één plek)
     ========================================================================== */

  // Lettermaat -> productiematen. Bij twee maten bepaalt de pasvorm (Slim = kleinste,
  // Regular = grootste) welke wordt gekozen; zonder voorkeur de ruimere (veiligste).
  var LETTER_SIZES = [
    { letter: 'XS',  numbers: [44],     chest: '±88 cm' },
    { letter: 'S',   numbers: [46],     chest: '±92 cm' },
    { letter: 'M',   numbers: [48, 50], chest: '±96–100 cm' },
    { letter: 'L',   numbers: [52],     chest: '±104 cm' },
    { letter: 'XL',  numbers: [54, 56], chest: '±108–112 cm' },
    { letter: 'XXL', numbers: [58, 60], chest: '±116–120 cm' },
    { letter: '3XL', numbers: [62],     chest: '±124 cm en groter' }
  ];

  // Leverbare productiematen. Pantalon is bewust afgekapt op 62 (maten 64–68 vervallen).
  var SIZE_RANGES = {
    colbert:  [42, 44, 46, 48, 50, 52, 54, 56, 58, 60, 62, 64, 66, 68],
    pantalon: [42, 44, 46, 48, 50, 52, 54, 56, 58, 60, 62]
  };

  // Bewegingsruimte (ease) in cm, gebruikt door de maatcalculator.
  var EASE = { chest: 5 /* 4–6 */, waist: 3 /* 2–4 */, hip: 3 };

  // Maattabellen (cm). Ruglengte bij colbert-maat 54 gecorrigeerd naar 76 (brondata-typo 67).
  var SIZE_TABLE = {
    colbert: {
      sizes: [42, 44, 46, 48, 50, 52, 54, 56, 58, 60, 62, 64, 66, 68],
      rows: [
        { label: 'A · 1/2 borst',  values: [47, 49, 51, 53, 55, 57, 59, 61, 63, 65, 67, 69, 71, 73] },
        { label: 'B · 1/2 taille', values: [41, 43, 45, 47, 49, 51, 53, 55, 57, 59, 61, 63, 65, 67] },
        { label: 'C · trapezium',  values: [41.4, 42.6, 43.8, 45, 46.2, 47.4, 48.6, 49.8, 51, 52.2, 53.4, 54.6, 55.8, 57] },
        { label: 'D · breedte',    values: [40.7, 41.9, 43.1, 44.3, 45.5, 46.7, 47.9, 49.1, 50.3, 51.5, 52.7, 53.9, 55.1, 56.3] },
        { label: 'E · ruglengte',  values: [73, 73.5, 74, 74.5, 75, 75.5, 76, 76.5, 77, 77.5, 78, 78.5, 79, 79.5] },
        { label: 'F · mouwlengte', values: [63, 63.5, 64, 64.5, 65, 65.5, 66, 66.5, 67, 67.5, 68, 68.5, 69, 69.5] },
        { label: 'G · 1/2 biceps', values: [17.8, 18.4, 19, 19.6, 20.2, 20.8, 21.4, 22, 22.6, 23.2, 23.8, 24.4, 25, 25.6] }
      ]
    },
    pantalon: {
      sizes: [42, 44, 46, 48, 50, 52, 54, 56, 58, 60, 62],
      rows: [
        { label: 'A · 1/2 taille',        values: [36, 38, 40, 42, 44, 46, 48, 50, 52, 54, 56] },
        { label: 'B · 1/2 heup',          values: [44.5, 46.5, 48.5, 50.5, 52.5, 54.5, 56.5, 58.5, 60.5, 62.5, 64.5] },
        { label: 'C · 1/2 dij',           values: [29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39] },
        { label: 'D · 1/2 knie',          values: [20.4, 20.8, 21.2, 21.6, 22, 22.4, 22.8, 23.2, 23.6, 24, 24.4] },
        { label: 'E · 1/2 onderpijp',     values: [16.6, 17, 17.4, 17.8, 18.2, 18.6, 19, 19.4, 19.8, 20.2, 20.6] },
        { label: 'F · voorrijs',          values: [17.8, 18.3, 18.8, 19.3, 19.8, 20.3, 20.8, 21.3, 21.8, 22.3, 22.8] },
        { label: 'G · achterrijs',        values: [33.2, 34, 34.8, 35.6, 36.4, 37.2, 38, 38.8, 39.6, 40.4, 41.2] },
        { label: 'H · binnenbeenlengte',  values: [86, 86, 86, 86, 86, 86, 86, 86, 86, 86, 86] }
      ]
    }
  };

  // Invoergrenzen voor de calculator (vriendelijke validatie).
  var LIMITS = {
    height: [140, 220], weight: [40, 200],
    chest:  [80, 160],  waist:  [60, 160], hip: [70, 170]
  };

  /* --- Maatberekening (formules apart en becommentarieerd, makkelijk bij te stellen) --- */

  // Zoek de maat waarvan de tabelwaarde in rij `rowIndex` het dichtst bij `target` ligt.
  function sizeFromTableRow(which, rowIndex, target, fit) {
    var t = SIZE_TABLE[which];
    var row = t.rows[rowIndex].values;
    var sizes = t.sizes;
    if (target <= row[0]) return sizes[0];
    if (target >= row[row.length - 1]) return sizes[sizes.length - 1];
    for (var i = 0; i < row.length - 1; i++) {
      if (target >= row[i] && target <= row[i + 1]) {
        if (fit === 'slim') return sizes[i];
        if (fit === 'regular') return sizes[i + 1];
        return (Math.abs(row[i] - target) <= Math.abs(row[i + 1] - target)) ? sizes[i] : sizes[i + 1];
      }
    }
    return sizes[sizes.length - 1];
  }

  // Colbertmaat uit borstomvang. De 1/2 borst van het pak hoort ~4–6 cm ruimer dan de halve lichaamsborst.
  function colbertFromChest(chestCm, fit) {
    return sizeFromTableRow('colbert', 0, (chestCm / 2) + EASE.chest, fit);
  }

  // Pantalonmaat uit tailleomvang (en optioneel heup). Bij verschil taille/heup de grotere kiezen.
  function pantalonFromWaist(waistCm, hipCm, fit) {
    var size = sizeFromTableRow('pantalon', 0, (waistCm + EASE.waist) / 2, fit);
    if (hipCm) {
      var hipSize = sizeFromTableRow('pantalon', 1, (hipCm + EASE.hip) / 2, fit);
      if (hipSize > size) size = hipSize;
    }
    return size;
  }

  // Schatting borstomvang (cm) uit lengte & gewicht.
  // Geijkt op realistische profielen: 181/70 -> ~94 (S/M), 175/85 -> ~104 (L), 190/95 -> ~108 (XL).
  // Gewicht is de belangrijkste factor; grotere lengte bij gelijk gewicht = iets slanker.
  // Bij te stellen op basis van retourdata.
  function estimateChestFromHeightWeight(heightCm, weightKg) {
    return Math.round(0.6 * weightKg + 52 - (heightCm - 180) * 0.1);
  }

  // Ruwe taille-schatting uit borst, alleen voor de snelle modus van de pantalon.
  function estimateWaistFromChest(chestCm) { return Math.round(chestCm * 0.86); }

  /* --- Letter <-> nummer helpers --- */
  function letterFromNumber(n) {
    for (var i = 0; i < LETTER_SIZES.length; i++) {
      if (LETTER_SIZES[i].numbers.indexOf(n) !== -1) return LETTER_SIZES[i].letter;
    }
    if (n > 62) return '3XL';
    if (n < 44) return 'XS';
    return '';
  }
  function numberFromLetter(letter, sizeType, fit) {
    var entry = null;
    for (var i = 0; i < LETTER_SIZES.length; i++) if (LETTER_SIZES[i].letter === letter) entry = LETTER_SIZES[i];
    if (!entry) return null;
    var avail = SIZE_RANGES[sizeType] || SIZE_RANGES.colbert;
    var pool = entry.numbers.filter(function (n) { return avail.indexOf(n) !== -1; });
    if (!pool.length) pool = entry.numbers.slice();
    if (pool.length === 1) return pool[0];
    if (fit === 'slim') return Math.min.apply(null, pool);
    if (fit === 'regular') return Math.max.apply(null, pool);
    return Math.max.apply(null, pool);
  }

  /* --- DOM-helpers --- */
  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === 'class') node.className = attrs[k];
      else if (k === 'html') node.innerHTML = attrs[k];
      else if (k === 'text') node.textContent = attrs[k];
      else if (k.slice(0, 2) === 'on' && typeof attrs[k] === 'function') node.addEventListener(k.slice(2), attrs[k]);
      else if (attrs[k] != null && attrs[k] !== false) node.setAttribute(k, attrs[k]);
    });
    (children || []).forEach(function (c) { if (c != null) node.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return node;
  }
  function clampInt(v) { v = parseInt(v, 10); return isNaN(v) ? null : v; }
  var SKIP_VALUE = 'Telefonisch bepalen';

  // De getoonde maat is nadrukkelijk een eerste uitgangspunt, geen definitieve productiemaat.
  var ADVISORY_NOTE = 'Dit is alleen een eerste indicatie. Binnen 24 uur na je bestelling nemen wij persoonlijk contact met je op om jouw lichaamsmaten, gewenste pasvorm en details te controleren. Pas na jouw akkoord gaat het maatpak in productie.';

  /* ==========================================================================
     Wizard (één instantie per product op de pagina)
     ========================================================================== */
  function Wizard(cfg) {
    this.cfg = cfg;
    this.data = (window.MSCVTR_SUIT_OPTIONS || {})[cfg.handle] || null;
    this.storageKey = 'mscvtr:v2:' + cfg.handle;
    this.state = this.load() || { swatch: {}, size: {}, measures: {}, text: {}, phoneMode: false };
    if (!this.state.measures) this.state.measures = {};
    this.stepIndex = 0;
    this.steps = this.buildSteps();
    this.calcMode = 'quick';
    this.calcFit = 'regular';
    this.build();
    this.applyPropsToForm();
    this.updateCta();
  }

  Wizard.prototype.buildSteps = function () {
    var steps = [{ kind: 'intro', key: 'intro', label: 'Start' }];
    if (this.data && this.data.swatchSteps) {
      this.data.swatchSteps.forEach(function (s) {
        steps.push({ kind: 'swatch', key: s.key, label: s.label, required: s.required, values: s.values || [] });
      });
    }
    steps.push({ kind: 'size', key: 'colbert', label: 'Colbertmaat', sizeType: 'colbert' });
    steps.push({ kind: 'size', key: 'pantalon', label: 'Pantalonmaat', sizeType: 'pantalon' });
    var textFields = (this.data && this.data.textSteps && this.data.textSteps.length)
      ? this.data.textSteps
      : [{ key: 'aanvullende_wensen_colbert', label: 'Aanvullende wensen colbert' },
         { key: 'aanvullende_wensen_pantalon', label: 'Aanvullende wensen pantalon' }];
    steps.push({ kind: 'text', key: 'wensen', label: 'Aanvullende wensen', fields: textFields });
    steps.push({ kind: 'overview', key: 'overview', label: 'Overzicht' });
    return steps;
  };

  /* ---- localStorage ---- */
  Wizard.prototype.save = function () { try { localStorage.setItem(this.storageKey, JSON.stringify(this.state)); } catch (e) {} };
  Wizard.prototype.load = function () { try { return JSON.parse(localStorage.getItem(this.storageKey) || 'null'); } catch (e) { return null; } };

  /* ---- Zichtbaarheid van stappen (telefonisch = alleen maten) ---- */
  Wizard.prototype.isVisible = function (step) {
    if (this.state.phoneMode && (step.kind === 'swatch' || step.kind === 'text')) return false;
    return true;
  };
  Wizard.prototype.visibleSteps = function () {
    var self = this;
    return this.steps.filter(function (s) { return self.isVisible(s); });
  };
  Wizard.prototype.nextIndex = function () {
    for (var j = this.stepIndex + 1; j < this.steps.length; j++) if (this.isVisible(this.steps[j])) return j;
    return -1;
  };
  Wizard.prototype.prevIndex = function () {
    for (var j = this.stepIndex - 1; j >= 0; j--) if (this.isVisible(this.steps[j])) return j;
    return -1;
  };
  Wizard.prototype.firstSizeIndex = function () {
    for (var i = 0; i < this.steps.length; i++) if (this.steps[i].kind === 'size') return i;
    return 0;
  };

  /* ---- Opbouw DOM ---- */
  Wizard.prototype.build = function () {
    var self = this;
    this.steps.forEach(function (step) {
      if (step.kind === 'swatch' && step.values.length === 1 && !self.state.swatch[step.key]) {
        var v0 = step.values[0];
        self.state.swatch[step.key] = { label: v0.label, code: v0.code || null, image: v0.image || null };
      }
    });

    this.overlay = el('div', { class: 'mscvtr mscvtr-overlay', role: 'dialog', 'aria-modal': 'true', 'aria-label': 'Stel je maatpak samen', hidden: 'hidden' });
    this.panel = el('div', { class: 'mscvtr-panel' });
    this.overlay.appendChild(this.panel);

    this.headerTitle = el('h2', { class: 'mscvtr-panel__title', text: 'Stel je maatpak samen' });
    this.headerStep = el('span', { class: 'mscvtr-panel__step' });
    var closeBtn = el('button', { class: 'mscvtr-close', type: 'button', 'aria-label': 'Sluiten', html: '&times;', onclick: function () { self.close(); } });
    this.progressFill = el('div', { class: 'mscvtr-progress__fill' });
    var header = el('div', { class: 'mscvtr-panel__header' }, [
      el('div', { class: 'mscvtr-panel__bar' }, [this.headerTitle, this.headerStep, closeBtn]),
      el('div', { class: 'mscvtr-progress' }, [this.progressFill])
    ]);

    this.body = el('div', { class: 'mscvtr-panel__body' });

    this.backBtn = el('button', { class: 'mscvtr-btn mscvtr-btn--ghost mscvtr-btn--back', type: 'button', text: 'Vorige', onclick: function () { self.prev(); } });
    this.nextBtn = el('button', { class: 'mscvtr-btn mscvtr-btn--primary', type: 'button', onclick: function () { self.next(); } });
    this.footer = el('div', { class: 'mscvtr-panel__footer' }, [this.backBtn, this.nextBtn]);

    this.panel.appendChild(header);
    this.panel.appendChild(this.body);
    this.panel.appendChild(this.footer);

    this.modal = this.buildTableModal();

    this.overlay.addEventListener('click', function (e) { if (e.target === self.overlay) self.close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && self.overlay.classList.contains('is-open')) self.close(); });

    document.body.appendChild(this.overlay);
    document.body.appendChild(this.modal.root);

    var cta = document.querySelector(this.cfg.ctaSelector);
    if (cta) {
      cta.hidden = false;
      this.ctaEl = cta;
      this.summaryEl = cta.querySelector('[data-mscvtr-summary]');
      var openBtn = cta.querySelector('[data-mscvtr-open]');
      if (openBtn) openBtn.addEventListener('click', function () { self.open(); });
    }

    this.propsEl = document.querySelector('[data-mscvtr-props]');
    this.form = document.getElementById(this.cfg.formId);
  };

  /* ---- Openen / sluiten ---- */
  Wizard.prototype.open = function (index) {
    if (typeof index === 'number') this.stepIndex = index;
    if (!this.isVisible(this.steps[this.stepIndex])) this.stepIndex = 0;
    this.overlay.hidden = false;
    var self = this;
    requestAnimationFrame(function () { self.overlay.classList.add('is-open'); });
    document.body.classList.add('mscvtr-lock');
    this.render();
  };
  Wizard.prototype.close = function () {
    this.overlay.classList.remove('is-open');
    document.body.classList.remove('mscvtr-lock');
    var overlay = this.overlay;
    setTimeout(function () { if (!overlay.classList.contains('is-open')) overlay.hidden = true; }, 250);
    this.applyPropsToForm();
    this.updateCta();
  };

  /* ---- Navigatie ---- */
  Wizard.prototype.next = function () {
    var step = this.steps[this.stepIndex];
    if (step.kind === 'size' && !this.state.size[step.key]) {
      this.flashRequired('Kies een maat om verder te gaan (of gebruik de maatcalculator).');
      return;
    }
    // Swatch zonder keuze = overslaan -> "Telefonisch bepalen"
    if (step.kind === 'swatch' && !this.state.swatch[step.key]) {
      this.state.swatch[step.key] = { label: SKIP_VALUE, skipped: true };
      this.save(); this.applyPropsToForm();
    }
    if (step.kind === 'overview') { this.addToCart(); return; }
    var j = this.nextIndex();
    if (j !== -1) { this.stepIndex = j; this.render(); }
  };
  Wizard.prototype.prev = function () {
    var j = this.prevIndex();
    if (j !== -1) { this.stepIndex = j; this.render(); }
  };
  Wizard.prototype.goto = function (i) { this.stepIndex = i; this.render(); };

  // Telefonisch: alle keuze-stappen overslaan, alleen maten kiezen.
  Wizard.prototype.startPhoneMode = function () {
    var self = this;
    this.state.phoneMode = true;
    this.steps.forEach(function (s) {
      if (s.kind === 'swatch') self.state.swatch[s.key] = { label: SKIP_VALUE, skipped: true };
    });
    this.save(); this.applyPropsToForm();
    this.stepIndex = this.firstSizeIndex();
    this.render();
  };
  Wizard.prototype.exitPhoneMode = function () {
    this.state.phoneMode = false;
    // wis de automatisch ingevulde "Telefonisch bepalen" waarden zodat de klant echt kan kiezen
    var self = this;
    this.steps.forEach(function (s) {
      if (s.kind === 'swatch' && self.state.swatch[s.key] && self.state.swatch[s.key].skipped) delete self.state.swatch[s.key];
    });
    this.save(); this.applyPropsToForm();
  };

  /* ---- Render ---- */
  Wizard.prototype.render = function () {
    try { this._render(); }
    catch (e) { if (window.console) console.error('[mscvtr] render fout', e); }
  };
  Wizard.prototype._render = function () {
    var step = this.steps[this.stepIndex];
    var visible = this.visibleSteps();
    var pos = visible.indexOf(step) + 1;
    var total = visible.length;
    this.headerStep.textContent = 'Stap ' + pos + ' van ' + total;
    this.progressFill.style.width = Math.round((pos / total) * 100) + '%';
    this.body.innerHTML = '';
    this.body.scrollTop = 0;

    if (step.kind === 'intro') this.renderIntro();
    else if (step.kind === 'swatch') this.renderSwatch(step);
    else if (step.kind === 'size') this.renderSize(step);
    else if (step.kind === 'text') this.renderText(step);
    else if (step.kind === 'overview') this.renderOverview(step);

    // Footer
    var isIntro = step.kind === 'intro';
    this.footer.style.display = isIntro ? 'none' : 'flex';
    this.backBtn.style.visibility = (this.prevIndex() === -1) ? 'hidden' : 'visible';
    if (step.kind === 'overview') {
      this.nextBtn.innerHTML = 'In winkelwagen &middot; ' + this.priceLabel();
    } else if (step.kind === 'size') {
      this.nextBtn.textContent = 'Volgende';
    } else if (step.kind === 'swatch') {
      this.nextBtn.textContent = this.state.swatch[step.key] && !this.state.swatch[step.key].skipped ? 'Volgende' : 'Overslaan';
    } else {
      this.nextBtn.textContent = 'Volgende';
    }
  };

  Wizard.prototype.flashRequired = function (msg) {
    var note = this.body.querySelector('[data-required-note]');
    if (note) { note.textContent = msg; note.style.color = '#b42318'; }
  };

  /* ---- Intro ---- */
  Wizard.prototype.renderIntro = function () {
    var self = this;
    this.body.appendChild(el('h3', { class: 'mscvtr-step__heading', text: 'Hoe wil je je pak samenstellen?' }));
    this.body.appendChild(el('p', { class: 'mscvtr-step__intro', text: 'Stel je pak zelf online samen, of laat het telefonisch doen. Je hoeft alleen je maat te kiezen.' }));
    this.body.appendChild(el('div', { class: 'mscvtr-size-actions' }, [
      el('button', { class: 'mscvtr-btn mscvtr-btn--primary mscvtr-btn--block mscvtr-btn--lg', type: 'button', text: 'Zelf online samenstellen', onclick: function () { if (self.state.phoneMode) self.exitPhoneMode(); self.next(); } }),
      el('button', { class: 'mscvtr-btn mscvtr-btn--outline mscvtr-btn--block', type: 'button', text: 'Liever telefonisch samenstellen?', onclick: function () { self.startPhoneMode(); } })
    ]));

    // Zo werkt het: maakt vooraf duidelijk dat er eerst een maatcontrole volgt.
    var steps = [
      ['Stel jouw pak samen', 'Kies model, afwerking, voering, knopen en details.'],
      ['Persoonlijke maatcontrole', 'Binnen 24 uur bellen we je om je maten en pasvorm te controleren.'],
      ['Productie van jouw maatpak', 'Pas na jouw akkoord gaat je pak in productie. Levertijd ongeveer 3,5 week (Express: 2,5 week).'],
      ['Perfecte pasvorm', 'Kleine correctie nodig? Wij vergoeden tot 70 euro bij een lokale kleermaker.']
    ];
    var list = el('ol', { class: 'mscvtr-flow' });
    steps.forEach(function (s, i) {
      list.appendChild(el('li', { class: 'mscvtr-flow__step' }, [
        el('span', { class: 'mscvtr-flow__num', text: String(i + 1) }),
        el('span', { class: 'mscvtr-flow__body' }, [
          el('span', { class: 'mscvtr-flow__title', text: s[0] }),
          el('span', { class: 'mscvtr-flow__text', text: s[1] })
        ])
      ]));
    });
    this.body.appendChild(el('p', { class: 'mscvtr-flow__heading', text: 'Zo werkt het' }));
    this.body.appendChild(list);

    var trust = [
      'Persoonlijk maatadvies',
      'Gratis en verzekerd verzonden',
      'Veilig betalen met onder andere iDEAL, Klarna en creditcard',
      'Showroom en telefonisch advies beschikbaar'
    ];
    var trustList = el('ul', { class: 'mscvtr-trust' });
    trust.forEach(function (t) {
      trustList.appendChild(el('li', {}, [
        el('span', { class: 'mscvtr-trust__check', html: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12.5l5 5 11-11" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>' }),
        el('span', { text: t })
      ]));
    });
    this.body.appendChild(trustList);
  };

  /* ---- Swatch-stap (geen codes tonen) ---- */
  Wizard.prototype.renderSwatch = function (step) {
    var self = this;
    this.body.appendChild(el('h3', { class: 'mscvtr-step__heading', text: step.label }));
    this.body.appendChild(el('p', { class: 'mscvtr-step__intro', text: 'Kies je ' + step.label.toLowerCase() + '.' }));

    var current = this.state.swatch[step.key];
    var grid = el('div', { class: 'mscvtr-swatches' + (step.values.length <= 2 ? ' mscvtr-swatches--wide' : '') });
    step.values.forEach(function (v) {
      var selected = current && !current.skipped && current.label === v.label;
      var visual = v.image
        ? el('img', { class: 'mscvtr-swatch__img', src: v.image, alt: v.label, loading: 'lazy' })
        : el('div', { class: 'mscvtr-swatch__noimg', text: v.label });
      var card = el('button', {
        class: 'mscvtr-swatch' + (selected ? ' is-selected' : ''), type: 'button',
        onclick: function () {
          self.state.swatch[step.key] = { label: v.label, code: v.code || null, image: v.image || null };
          self.save(); self.applyPropsToForm();
          self.render();
          setTimeout(function () { self.next(); }, 140);
        }
      }, [visual, el('span', { class: 'mscvtr-swatch__label', text: v.label })]);
      grid.appendChild(card);
    });
    this.body.appendChild(grid);

    // Neutrale overslaan-knop
    this.body.appendChild(el('div', { class: 'mscvtr-size-actions' }, [
      el('button', { class: 'mscvtr-linkbtn', type: 'button', text: 'Deze stap overslaan', onclick: function () {
        self.state.swatch[step.key] = { label: SKIP_VALUE, skipped: true };
        self.save(); self.applyPropsToForm(); self.next();
      } })
    ]));
  };

  /* ---- Maat-stap (versimpeld: alleen letters + calculator + maattabel-link) ---- */
  Wizard.prototype.renderSize = function (step) {
    var self = this;
    this.body.appendChild(el('h3', { class: 'mscvtr-step__heading', text: step.label }));
    this.body.appendChild(el('p', { class: 'mscvtr-step__intro', text: 'Een eerste indicatie. We nemen je maten persoonlijk met je door voordat je pak in productie gaat.' }));

    var current = this.state.size[step.key];

    var letterGrid = el('div', { class: 'mscvtr-sizes' });
    LETTER_SIZES.forEach(function (L) {
      var num = numberFromLetter(L.letter, step.sizeType, null);
      if (num == null) return;
      var selected = current && current.letter === L.letter;
      letterGrid.appendChild(el('button', {
        class: 'mscvtr-size' + (selected ? ' is-selected' : ''), type: 'button',
        onclick: function () { self.setSize(step, { number: num, letter: L.letter, source: current && current.source === 'calculator' && current.letter === L.letter ? 'calculator' : 'letter' }); self.render(); }
      }, [
        el('span', { class: 'mscvtr-size__letter', text: L.letter }),
        el('span', { class: 'mscvtr-size__hint', text: L.chest })
      ]));
    });
    this.body.appendChild(letterGrid);

    this.body.appendChild(el('p', { class: 'mscvtr-note', 'data-required-note': '', text: current ? ('Voorlopig maatadvies: ' + this.sizeText(step.key)) : '' }));

    // Kleine links: calculator + maattabel
    this.body.appendChild(el('div', { class: 'mscvtr-size-toolbar' }, [
      el('button', { class: 'mscvtr-linkbtn', type: 'button', text: 'Weet je je maat niet? Bereken hem', onclick: function () { self.toggleCalc(step); } }),
      el('button', { class: 'mscvtr-linkbtn', type: 'button', text: 'Maattabel & meetinstructies', onclick: function () { self.openTable(step.sizeType); } })
    ]));

    this.calcWrap = el('div');
    if (this._calcOpen) this.calcWrap.appendChild(this.buildCalculator(step));
    this.body.appendChild(this.calcWrap);
  };
  // (contactregel bewust weggelaten in de maatstappen om herhaling te beperken)

  Wizard.prototype.setSize = function (step, val) { this.state.size[step.key] = val; this.save(); this.applyPropsToForm(); };
  Wizard.prototype.toggleCalc = function (step) {
    this._calcOpen = !this._calcOpen; this.render();
    if (this._calcOpen) { var w = this.calcWrap; setTimeout(function () { if (w && w.scrollIntoView) w.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }, 30); }
  };

  Wizard.prototype.sizeText = function (key) {
    var s = this.state.size[key];
    if (!s) return '';
    return s.letter ? (s.letter + ' (' + s.number + ')') : String(s.number);
  };

  // Bijv. "Voorlopig maatadvies: colbert L (52) · pantalon M (48)"
  Wizard.prototype.advisoryLine = function () {
    var parts = [];
    if (this.state.size.colbert) parts.push('colbert ' + this.sizeText('colbert'));
    if (this.state.size.pantalon) parts.push('pantalon ' + this.sizeText('pantalon'));
    return parts.length ? ('Voorlopig maatadvies: ' + parts.join(' · ')) : '';
  };

  /* ---- Maatcalculator ---- */
  Wizard.prototype.buildCalculator = function (step) {
    var self = this;
    var root = el('div', { class: 'mscvtr-calc' });
    var tabQuick = el('button', { class: 'mscvtr-calc__tab' + (this.calcMode === 'quick' ? ' is-active' : ''), type: 'button', text: 'Snel (lengte & gewicht)', onclick: function () { self.calcMode = 'quick'; self.refreshCalc(step); } });
    var tabPrecise = el('button', { class: 'mscvtr-calc__tab' + (this.calcMode === 'precise' ? ' is-active' : ''), type: 'button', text: 'Nauwkeurig (meten)', onclick: function () { self.calcMode = 'precise'; self.refreshCalc(step); } });
    root.appendChild(el('div', { class: 'mscvtr-calc__tabs' }, [tabQuick, tabPrecise]));
    var bodyEl = el('div', { class: 'mscvtr-calc__body' });
    this.calcBody = bodyEl;
    root.appendChild(bodyEl);
    this.renderCalcBody(step);
    return root;
  };
  Wizard.prototype.refreshCalc = function (step) {
    var fresh = this.buildCalculator(step);
    this.calcWrap.innerHTML = '';
    this.calcWrap.appendChild(fresh);
  };

  Wizard.prototype.renderCalcBody = function (step) {
    var self = this;
    var isColbert = step.sizeType === 'colbert';
    var body = this.calcBody;
    body.innerHTML = '';

    function fitRow() {
      var slim = el('button', { class: self.calcFit === 'slim' ? 'is-active' : '', type: 'button', text: 'Slim', onclick: function () { self.calcFit = 'slim'; self.renderCalcBody(step); } });
      var reg = el('button', { class: self.calcFit === 'regular' ? 'is-active' : '', type: 'button', text: 'Regular', onclick: function () { self.calcFit = 'regular'; self.renderCalcBody(step); } });
      return el('div', { class: 'mscvtr-field' }, [el('label', { text: 'Pasvoorkeur' }), el('div', { class: 'mscvtr-segmented' }, [slim, reg])]);
    }

    var errorEl = el('p', { class: 'mscvtr-calc__error' });
    var resultEl = el('div');

    if (this.calcMode === 'quick') {
      var heightIn = el('input', { class: 'mscvtr-input', type: 'number', inputmode: 'numeric', min: LIMITS.height[0], max: LIMITS.height[1], placeholder: 'bijv. 182' });
      var weightIn = el('input', { class: 'mscvtr-input', type: 'number', inputmode: 'numeric', min: LIMITS.weight[0], max: LIMITS.weight[1], placeholder: 'bijv. 80' });
      body.appendChild(el('div', { class: 'mscvtr-field' }, [el('label', { text: 'Lichaamslengte (cm)' }), heightIn]));
      body.appendChild(el('div', { class: 'mscvtr-field' }, [el('label', { text: 'Gewicht (kg)' }), weightIn]));
      body.appendChild(fitRow());
      body.appendChild(errorEl);
      body.appendChild(el('button', {
        class: 'mscvtr-btn mscvtr-btn--primary mscvtr-btn--block', type: 'button', text: 'Bereken mijn maat',
        onclick: function () {
          errorEl.textContent = '';
          var h = clampInt(heightIn.value), w = clampInt(weightIn.value);
          var err = self.validate([[h, LIMITS.height, 'lengte'], [w, LIMITS.weight, 'gewicht']]);
          if (err) { errorEl.textContent = err; return; }
          var chest = estimateChestFromHeightWeight(h, w);
          self.state.measures.estimatedChest = chest;
          var num = isColbert ? colbertFromChest(chest, self.calcFit) : pantalonFromWaist(estimateWaistFromChest(chest), null, self.calcFit);
          self.showCalcResult(step, resultEl, num, 'Indicatie op basis van lengte & gewicht. Meten (tab "Nauwkeurig") is nauwkeuriger.');
        }
      }));
      body.appendChild(resultEl);
      body.appendChild(el('p', { class: 'mscvtr-field__hint', text: 'We schatten je borstomvang uit lengte en gewicht en leiden daaruit de maat af.' }));
    } else {
      if (isColbert) {
        var chestIn = el('input', { class: 'mscvtr-input', type: 'number', inputmode: 'numeric', min: LIMITS.chest[0], max: LIMITS.chest[1], placeholder: 'bijv. 102' });
        body.appendChild(el('div', { class: 'mscvtr-field' }, [
          el('label', { text: 'Borstomvang (cm)' }), chestIn,
          el('span', { class: 'mscvtr-field__hint', html: measureIcon() + ' Meet horizontaal op het breedste punt van je borst, over een overhemd.' })
        ]));
        body.appendChild(fitRow());
        body.appendChild(errorEl);
        body.appendChild(el('button', {
          class: 'mscvtr-btn mscvtr-btn--primary mscvtr-btn--block', type: 'button', text: 'Bereken mijn maat',
          onclick: function () {
            errorEl.textContent = '';
            var c = clampInt(chestIn.value);
            var err = self.validate([[c, LIMITS.chest, 'borstomvang']]);
            if (err) { errorEl.textContent = err; return; }
            self.state.measures.chest = c;
            self.showCalcResult(step, resultEl, colbertFromChest(c, self.calcFit), 'Berekend uit je borstomvang met bewegingsruimte.');
          }
        }));
      } else {
        var waistIn = el('input', { class: 'mscvtr-input', type: 'number', inputmode: 'numeric', min: LIMITS.waist[0], max: LIMITS.waist[1], placeholder: 'bijv. 88' });
        var hipIn = el('input', { class: 'mscvtr-input', type: 'number', inputmode: 'numeric', min: LIMITS.hip[0], max: LIMITS.hip[1], placeholder: 'optioneel' });
        body.appendChild(el('div', { class: 'mscvtr-field' }, [
          el('label', { text: 'Tailleomvang (cm)' }), waistIn,
          el('span', { class: 'mscvtr-field__hint', html: measureIcon() + ' Meet rond je middel, waar de broeksband zit.' })
        ]));
        body.appendChild(el('div', { class: 'mscvtr-field' }, [
          el('label', { text: 'Heupomvang (cm), optioneel' }), hipIn,
          el('span', { class: 'mscvtr-field__hint', text: 'Meet rond het breedste punt van je heupen.' })
        ]));
        body.appendChild(fitRow());
        body.appendChild(errorEl);
        body.appendChild(el('button', {
          class: 'mscvtr-btn mscvtr-btn--primary mscvtr-btn--block', type: 'button', text: 'Bereken mijn maat',
          onclick: function () {
            errorEl.textContent = '';
            var wa = clampInt(waistIn.value), hi = clampInt(hipIn.value);
            var checks = [[wa, LIMITS.waist, 'tailleomvang']];
            if (hipIn.value) checks.push([hi, LIMITS.hip, 'heupomvang']);
            var err = self.validate(checks);
            if (err) { errorEl.textContent = err; return; }
            self.state.measures.waist = wa;
            if (hi) self.state.measures.hip = hi;
            var note = (hi && pantalonFromWaist(wa, null, self.calcFit) !== pantalonFromWaist(wa, hi, self.calcFit))
              ? 'Taille en heup wijzen naar verschillende maten. We kozen de grotere; laat de taille eventueel innemen via de aanpassingsgarantie.'
              : 'Berekend uit je tailleomvang met ruimte.';
            self.showCalcResult(step, resultEl, pantalonFromWaist(wa, hi, self.calcFit), note);
          }
        }));
      }
      body.appendChild(resultEl);
    }
  };

  Wizard.prototype.showCalcResult = function (step, container, num, note) {
    var self = this;
    this.save();
    var letter = letterFromNumber(num);
    var neighbors = this.neighborText(num, step.sizeType);
    container.innerHTML = '';
    container.appendChild(el('div', { class: 'mscvtr-calc__result' }, [
      el('div', { class: 'mscvtr-calc__result-size', text: 'Voorlopig maatadvies: ' + (letter ? letter + ' (' + num + ')' : num) }),
      el('p', { class: 'mscvtr-calc__result-note', text: note }),
      neighbors ? el('p', { class: 'mscvtr-calc__result-note', text: neighbors }) : null,
      el('button', {
        class: 'mscvtr-btn mscvtr-btn--primary mscvtr-btn--block', type: 'button', text: 'Deze maat overnemen',
        onclick: function () {
          self.state.size[step.key] = { number: num, letter: letter, source: 'calculator' };
          self.save(); self.applyPropsToForm();
          self._calcOpen = false;
          self.render();
        }
      })
    ]));
  };

  Wizard.prototype.neighborText = function (num, sizeType) {
    var arr = SIZE_RANGES[sizeType];
    var i = arr.indexOf(num);
    if (i === -1) return '';
    var lower = arr[i - 1], upper = arr[i + 1];
    if (lower && upper) return 'Tussen twee maten? ' + letterFromNumber(lower) + ' valt slanker, ' + letterFromNumber(upper) + ' ruimer.';
    return '';
  };

  Wizard.prototype.validate = function (checks) {
    for (var i = 0; i < checks.length; i++) {
      var v = checks[i][0], range = checks[i][1], name = checks[i][2];
      if (v == null) return 'Vul een geldige ' + name + ' in.';
      if (v < range[0] || v > range[1]) return 'Controleer je ' + name + ':kies een waarde tussen ' + range[0] + ' en ' + range[1] + '.';
    }
    return null;
  };

  /* ---- Tekst-stap ---- */
  Wizard.prototype.renderText = function (step) {
    var self = this;
    this.body.appendChild(el('h3', { class: 'mscvtr-step__heading', text: 'Aanvullende wensen' }));
    this.body.appendChild(el('p', { class: 'mscvtr-step__intro', text: 'Optioneel. Specifieke wensen voor colbert of pantalon? Laat het hier weten, anders bespreken we ze telefonisch.' }));
    step.fields.forEach(function (f) {
      var ta = el('textarea', { class: 'mscvtr-input', rows: '3', placeholder: 'Bijv. voorkeuren, opmerkingen…' });
      ta.value = self.state.text[f.key] || '';
      ta.addEventListener('input', function () { self.state.text[f.key] = ta.value; self.save(); self.applyPropsToForm(); });
      self.body.appendChild(el('div', { class: 'mscvtr-field' }, [el('label', { text: f.label }), ta]));
    });
  };

  /* ---- Overzicht (met thumbnails + echte prijs) ---- */
  Wizard.prototype.renderOverview = function () {
    var self = this;
    this.body.appendChild(el('h3', { class: 'mscvtr-step__heading', text: 'Overzicht van je pak' }));
    this.body.appendChild(el('p', { class: 'mscvtr-step__intro', text: this.cfg.title + ' · ' + this.priceLabelText() }));

    if (this.advisoryLine()) {
      this.body.appendChild(el('div', { class: 'mscvtr-advisory' }, [
        el('p', { class: 'mscvtr-advisory__line', text: this.advisoryLine() }),
        el('p', { class: 'mscvtr-advisory__note', text: ADVISORY_NOTE })
      ]));
    }

    var list = el('ul', { class: 'mscvtr-summary-list' });
    this.steps.forEach(function (step, idx) {
      if (step.kind === 'swatch') {
        var v = self.state.swatch[step.key];
        var val = v ? (v.skipped ? SKIP_VALUE : v.label) : 'Nog niet gekozen';
        list.appendChild(self.summaryRow(step.label, val, idx, { image: (v && !v.skipped) ? v.image : null, muted: !v || v.skipped }));
      } else if (step.kind === 'size') {
        var s = self.state.size[step.key];
        list.appendChild(self.summaryRow(step.label, s ? self.sizeText(step.key) : 'Nog niet gekozen', idx, { muted: !s }));
      } else if (step.kind === 'text') {
        step.fields.forEach(function (f) {
          var t = self.state.text[f.key];
          if (t && t.trim()) list.appendChild(self.summaryRow(f.label, t, idx, {}));
        });
      }
    });
    var m = this.state.measures;
    if (m.chest) list.appendChild(this.summaryRow('Borstomvang klant', m.chest + ' cm', null, {}));
    if (m.waist) list.appendChild(this.summaryRow('Tailleomvang klant', m.waist + ' cm', null, {}));
    if (m.hip) list.appendChild(this.summaryRow('Heupomvang klant', m.hip + ' cm', null, {}));
    this.body.appendChild(list);

    this.body.appendChild(el('div', { class: 'mscvtr-disclaimer', html:
      '<strong>Let op:</strong> dit is maatwerk en daarom uitgesloten van het herroepingsrecht (geen retour of ruil). ' +
      'Kleine correcties na levering vergoeden we tot €70 via de <a href="' + this.cfg.links.adjustmentGuarantee + '" target="_blank" rel="noopener">aanpassingsgarantie</a>.' }));
    this.body.appendChild(this.contactNote());
  };

  Wizard.prototype.summaryRow = function (label, value, editIndex, opts) {
    var self = this;
    opts = opts || {};
    var thumb = opts.image
      ? el('img', { class: 'mscvtr-summary-thumb', src: opts.image, alt: '', loading: 'lazy' })
      : null;
    var valueEl = el('div', { class: 'mscvtr-summary-item__value' + (opts.muted ? ' mscvtr-summary-item__value--later' : ''), text: value });
    var left = el('div', { class: 'mscvtr-summary-item__main' }, [
      thumb,
      el('div', {}, [el('div', { class: 'mscvtr-summary-item__label', text: label }), valueEl])
    ]);
    var right = (editIndex != null)
      ? el('button', { class: 'mscvtr-summary-edit', type: 'button', html: editPencil() + '<span>Wijzig</span>', onclick: function () { self.goto(editIndex); } })
      : null;
    return el('li', { class: 'mscvtr-summary-item' }, [left, right]);
  };

  /* ---- Persoonlijke service ---- */
  Wizard.prototype.contactNote = function () {
    var c = this.cfg.contact;
    return el('div', { class: 'mscvtr-note mscvtr-note--info', html:
      'Vragen over je maat? <a href="tel:' + c.phoneHref + '">' + c.phone + '</a> · <a href="mailto:' + c.email + '">' + c.email + '</a>' });
  };

  /* ==========================================================================
     Prijs
     ========================================================================== */
  Wizard.prototype.hasSale = function () {
    return this.cfg.compareAtPrice && this.cfg.compareAtPrice > this.cfg.price;
  };
  Wizard.prototype.priceLabel = function () {
    if (this.hasSale()) return '<s style="opacity:.7">' + this.cfg.compareAtFormatted + '</s> ' + this.cfg.priceFormatted;
    return this.cfg.priceFormatted;
  };
  Wizard.prototype.priceLabelText = function () {
    if (this.hasSale()) return this.cfg.priceFormatted + ' (van ' + this.cfg.compareAtFormatted + ')';
    return this.cfg.priceFormatted;
  };

  /* ==========================================================================
     Line item properties
     ========================================================================== */
  Wizard.prototype.collectProps = function () {
    var props = {};
    var self = this;
    (this.data && this.data.swatchSteps || []).forEach(function (s) {
      var v = self.state.swatch[s.key];
      if (v) props[s.label] = v.skipped ? SKIP_VALUE : (v.label + (v.code ? ' (' + v.code + ')' : ''));
    });
    if (this.state.size.colbert) props['Colbertmaat'] = this.sizeText('colbert');
    if (this.state.size.pantalon) props['Pantalonmaat'] = this.sizeText('pantalon');
    if (this.state.size.colbert || this.state.size.pantalon) {
      props['Maatadvies'] = 'Voorlopig. Maten worden telefonisch bevestigd voordat het pak in productie gaat.';
    }
    var m = this.state.measures;
    if (m.chest) props['Borstomvang klant'] = m.chest + ' cm';
    if (m.waist) props['Tailleomvang klant'] = m.waist + ' cm';
    if (m.hip) props['Heupomvang klant'] = m.hip + ' cm';
    if (this.state.phoneMode) props['Samenstellen'] = 'Telefonisch afgesproken';
    var textFields = (this.data && this.data.textSteps) || [];
    textFields.forEach(function (f) {
      var t = self.state.text[f.key];
      if (t && t.trim()) props[f.label] = t.trim();
    });
    return props;
  };

  Wizard.prototype.applyPropsToForm = function () {
    if (!this.propsEl) this.propsEl = document.querySelector('[data-mscvtr-props]');
    if (!this.propsEl) return;
    var props = this.collectProps();
    this.propsEl.innerHTML = '';
    var formId = this.cfg.formId;
    Object.keys(props).forEach(function (label) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + label + ']';
      input.value = props[label];
      input.setAttribute('form', formId);
      this.propsEl.appendChild(input);
    }, this);
  };

  /* ==========================================================================
     Status / add-to-cart
     ========================================================================== */
  Wizard.prototype.isComplete = function () { return !!(this.state.size.colbert && this.state.size.pantalon); };

  Wizard.prototype.updateCta = function () {
    if (!this.summaryEl) return;
    if (this.isComplete()) {
      this.summaryEl.innerHTML = '<b>' + this.advisoryLine() + '</b>. Wij bevestigen je maten persoonlijk voordat je pak in productie gaat.';
    } else if (Object.keys(this.state.swatch).length || Object.keys(this.state.size).length) {
      this.summaryEl.innerHTML = 'Je bent begonnen. Rond je pak af in een paar stappen.';
    } else {
      this.summaryEl.innerHTML = 'Voering, knopen, maten en meer. In een paar stappen klaar.';
    }
  };

  Wizard.prototype.addToCart = function () {
    var self = this;
    if (!this.isComplete()) { this.open(this.firstSizeIndex()); return; }
    var props = this.collectProps();
    var idInput = this.form && this.form.querySelector('[name="id"]');
    var variantId = idInput ? idInput.value : (this.cfg.variantId || '');

    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', '1');
    Object.keys(props).forEach(function (k) { fd.append('properties[' + k + ']', props[k]); });

    if (this.nextBtn) { this.nextBtn.disabled = true; this.nextBtn.innerHTML = 'Bezig…'; }

    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
      .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); return r.json(); })
      .then(function () { window.location.href = '/cart'; })
      .catch(function (err) {
        if (window.console) console.error('[mscvtr] toevoegen mislukt', err);
        if (self.nextBtn) { self.nextBtn.disabled = false; self.nextBtn.innerHTML = 'In winkelwagen &middot; ' + self.priceLabel(); }
        var msg = (err && err.description) ? err.description : 'Toevoegen aan winkelwagen lukte niet. Probeer het opnieuw.';
        var existing = self.body.querySelector('.mscvtr-calc__error');
        if (existing) existing.textContent = msg; else self.body.insertBefore(el('p', { class: 'mscvtr-calc__error', text: msg }), self.body.firstChild);
      });
  };

  /* ==========================================================================
     Maattabel-modal
     ========================================================================== */
  Wizard.prototype.buildTableModal = function () {
    var titleEl = el('h3', { class: 'mscvtr-modal__title' });
    var bodyEl = el('div', { class: 'mscvtr-modal__body' });
    var closeBtn = el('button', { class: 'mscvtr-close', type: 'button', 'aria-label': 'Sluiten', html: '&times;', onclick: function () { root.classList.remove('is-open'); } });
    var inner = el('div', { class: 'mscvtr-modal__inner' }, [el('div', { class: 'mscvtr-modal__head' }, [titleEl, closeBtn]), bodyEl]);
    var root = el('div', { class: 'mscvtr mscvtr-modal' }, [inner]);
    root.addEventListener('click', function (e) { if (e.target === root) root.classList.remove('is-open'); });
    return { root: root, title: titleEl, body: bodyEl };
  };

  Wizard.prototype.openTable = function (which) {
    var t = SIZE_TABLE[which];
    this.modal.title.textContent = (which === 'colbert' ? 'Maattabel colbert' : 'Maattabel pantalon') + ' (cm)';
    this.modal.body.innerHTML = '';
    var guide = el('ul', { class: 'mscvtr-measure-guide' });
    var tips = which === 'colbert'
      ? [['Borst', 'Meet horizontaal op het breedste punt van je borst, over een overhemd.'],
         ['Taille', 'Meet rond je natuurlijke taille.'],
         ['Mouwlengte', 'Van schoudernaad tot pols, arm licht gebogen.']]
      : [['Taille', 'Meet rond je middel, waar de broeksband zit.'],
         ['Heup', 'Meet rond het breedste punt van je heupen.'],
         ['Binnenbeen', 'Van kruis tot enkel, langs de binnenkant van het been.']];
    tips.forEach(function (tip) { guide.appendChild(el('li', {}, [el('span', { html: measureIcon() }), el('span', { html: '<strong>' + tip[0] + ':</strong> ' + tip[1] })])); });
    this.modal.body.appendChild(guide);
    var head = el('tr', {}, [el('th', { text: 'Meting' })].concat(t.sizes.map(function (s) { return el('th', { text: String(s) }); })));
    var tbody = el('tbody', {}, t.rows.map(function (r) {
      return el('tr', {}, [el('th', { text: r.label })].concat(r.values.map(function (v) { return el('td', { text: String(v) }); })));
    }));
    var table = el('table', { class: 'mscvtr-table' }, [el('thead', {}, [head]), tbody]);
    this.modal.body.appendChild(el('div', { class: 'mscvtr-tablewrap' }, [table]));
    this.modal.root.classList.add('is-open');
  };

  /* --- Iconen --- */
  function measureIcon() {
    return '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#334660" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 3 3 21"/><path d="M16 3h5v5"/><path d="M3 16v5h5"/></svg>';
  }
  function editPencil() {
    return '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg>';
  }

  /* --- Bootstrap --- */
  function init() {
    var configs = window.MSCVTR_WIZARD_CONFIG || {};
    Object.keys(configs).forEach(function (pid) {
      var cfg = configs[pid];
      if (cfg.__inited) return;
      cfg.__inited = true;
      try { new Wizard(cfg); } catch (e) { if (window.console) console.error('[mscvtr] wizard init faalde', e); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
